import React from "react";

const Body = ({ renderGeopicker, renderField, Button, ...props }) => {
    const { name, geozone } = props;

    return (
        <>
            {renderField(name)}
            {renderGeopicker({ ...geozone, withoutRadius: true })}
            {!!Button && <Button />}
        </>
    );
};

export default Body;
